<main>
  <form class="container-fluid main-container my-5" [formGroup]="passwordForm">
    <a class="text-decoration-none" routerLink="../">
      <i class="bi bi-arrow-left me-2"></i>Vorige pagina
    </a>
    <h1 class="subtitle mt-5">Wachtwoord wijzigen</h1>
    <hr>
    <div class="alert alert-success" role="alert" *ngIf="displaySuccess">
      {{ successText }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="displayError">
      {{ errorText }}
    </div>
    <label for="userPass" class="form-label required-input">Huidig wachtwoord</label>
    <input type="password" class="form-control form-input" formControlName="userPass" id="userPass">
    <div class="text-danger mt-1" *ngIf="(userPass?.dirty || userPass?.touched || formSubmitted) && userPass?.errors">
      <span *ngIf="userPass?.errors?.['required']">Dit veld is vereist</span>
    </div>
    <label for="userPassNew" class="form-label mt-3 required-input">Nieuw wachtwoord</label>
    <input type="password" class="form-control form-input" formControlName="userPassNew" id="userPassNew">
    <div class="text-danger mt-1" *ngIf="(userPassNew?.dirty || userPassNew?.touched || formSubmitted) && userPassNew?.errors">
      <span *ngIf="userPassNew?.errors?.['required']">Dit veld is vereist</span>
      <span *ngIf="userPassNew?.errors?.['minlength']">Wachtwoord moet minimaal 6 en maximaal 100 tekens bevatten.</span>
    </div>
    <p class="form-text text-md-end mt-2 url">*Verplichte velden</p>

    <div class="text-center">
      <button type="submit" class="btn btn-primary mb-4 btn-register m-auto mt-5" (click)="changePassword()">Wijzigen</button>
    </div>
  </form>
</main>
